var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6962 3H8.30383C5.37847 3 3 5.37847 3 8.30383V15.6962C3 18.6215 5.37847 21 8.30383 21H15.6962C18.6215 21 21 18.6215 21 15.6962V8.30383C21 5.37847 18.6215 3 15.6962 3ZM19.8181 15.6962C19.8181 17.9682 17.9682 19.8181 15.6962 19.8181H8.30383C6.03181 19.8181 4.18189 17.9682 4.18189 15.6962V8.30383C4.18189 6.03181 6.03181 4.18189 8.30383 4.18189H15.6962C17.9682 4.18189 19.8181 6.03181 19.8181 8.30383V15.6962Z",
    fill: "#5650F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9596 7.32382C9.33524 7.32382 7.19902 9.46003 7.19902 12.0844C7.19902 14.7088 9.33524 16.845 11.9596 16.845C14.584 16.845 16.7166 14.7088 16.7166 12.0844C16.7166 9.46003 14.584 7.32382 11.9596 7.32382ZM11.9596 15.6631C9.98858 15.6631 8.38091 14.0591 8.38091 12.0844C8.38091 10.1097 9.98491 8.50571 11.9596 8.50571C13.9343 8.50571 15.5383 10.1097 15.5383 12.0844C15.5383 14.0591 13.9307 15.6631 11.9596 15.6631Z",
    fill: "#5650F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0102 6.48695C16.6285 6.48695 16.3201 6.79527 16.3201 7.177C16.3201 7.55873 16.6285 7.86705 17.0102 7.86705C17.3919 7.86705 17.7002 7.55873 17.7002 7.177C17.7002 6.79527 17.3919 6.48695 17.0102 6.48695Z",
    fill: "#5650F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.03ffdc4d5d7724ad5b243ba572ebd15f.svg";
export { ForwardRef as ReactComponent };